import { Home, Building2, Warehouse, Car, Building, HelpCircle } from "lucide-react";
import { ADU_TYPES, WizardFormData } from "@/types/wizard";

interface Step3ADUTypeProps {
  formData: WizardFormData;
  updateFormData: (updates: Partial<WizardFormData>) => void;
  isDark: boolean;
}

const iconMap: Record<string, React.ReactNode> = {
  detached: <Home className="w-8 h-8" />,
  attached: <Building2 className="w-8 h-8" />,
  jadu: <Warehouse className="w-8 h-8" />,
  garage: <Car className="w-8 h-8" />,
  basement: <Building className="w-8 h-8" />,
  not_sure: <HelpCircle className="w-8 h-8" />,
};

const Step3ADUType = ({ formData, updateFormData, isDark }: Step3ADUTypeProps) => {
  const getCardStyles = (isSelected: boolean) => {
    if (isSelected) {
      return {
        backgroundColor: "#E4683B",
        color: "#ffffff",
        boxShadow: isDark
          ? "4px 4px 8px #000000, -4px -4px 8px #141414"
          : "4px 4px 8px #d1d1d1, -4px -4px 8px #ffffff",
      };
    }
    return {
      backgroundColor: isDark ? "#0a0a0a" : "#ffffff",
      color: isDark ? "#ffffff" : "#1a1a1a",
      boxShadow: isDark
        ? "4px 4px 8px #000000, -4px -4px 8px #141414"
        : "4px 4px 8px #d1d1d1, -4px -4px 8px #ffffff",
    };
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 
          className="text-2xl md:text-3xl font-bold mb-2"
          style={{ color: "#E4683B" }}
        >
          What type of ADU are you considering?
        </h2>
        <p 
          className="text-lg opacity-80"
          style={{ color: isDark ? "#ffffff" : "#1a1a1a" }}
        >
          Select the option that best fits your vision
        </p>
      </div>

      <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
        {ADU_TYPES.map((type) => {
          const isSelected = formData.aduType === type.value;
          
          return (
            <button
              key={type.value}
              onClick={() => updateFormData({ aduType: type.value })}
              className="p-6 rounded-2xl text-left transition-all duration-300 hover:scale-[1.02]"
              style={getCardStyles(isSelected)}
            >
              <div className="flex items-start gap-4">
                <div 
                  className="flex-shrink-0"
                  style={{ color: isSelected ? "#ffffff" : "#E4683B" }}
                >
                  {iconMap[type.value]}
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">{type.label}</h3>
                  <p 
                    className="text-sm"
                    style={{ opacity: isSelected ? 0.9 : 0.7 }}
                  >
                    {type.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Step3ADUType;
